
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34527',
  depVersions: {
  "documents-public-ui": "static-1.34527",
  "atom": "static-1.5078",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2502",
  "client-types": "static-1.466",
  "cssUtils": "static-1.794",
  "customer-data-filters-ui": "static-1.39791",
  "customer-data-objects": "static-1.7675",
  "customer-data-property-utils": "static-1.8096",
  "documents-lib": "static-1.34532",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.338",
  "FormsCommonComponents": "static-1.85860",
  "FormUrlGenerator": "static-2.4725",
  "foundations-theming-specialty": "static-1.2139",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5598",
  "hs-test-utils": "static-1.8019",
  "hub-http": "static-1.6228",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11784",
  "HubStyleTokens": "static-2.11477",
  "I18n": "static-7.1628",
  "icons": "static-2.647",
  "jasmine-immutable": "static-1.3027",
  "jasmine-runner": "static-1.6470",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7162",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5407",
  "quartz": "static-1.7040",
  "react": "static-7.186",
  "react-dlb": "static-1.79",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1-feat-id-1323-initial-url.10",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5348",
  "react-virtualized": "static-2.99",
  "reference-resolvers": "static-1.8177",
  "reference-resolvers-lite": "static-1.8100",
  "reporting-data": "static-1.67566",
  "reporting-reports": "static-1.67244",
  "reporting-snowflake": "static-1.56184",
  "reporting-testing-lib": "static-1.9499",
  "reporting-visualizations": "static-1.59642",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.8949",
  "sanitize": "static-1.4483",
  "sanitize-text": "static-1.8148",
  "self-service-api": "static-1.10254",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1754",
  "signup-constants": "static-1.18848",
  "signup-ui-url-generator": "static-2.8055",
  "StyleGuideUI": "static-3.487",
  "superstore": "static-1.4767",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4768",
  "ui-addon-form-validation": "static-1.10996",
  "ui-asset-management-lib": "static-1.11041",
  "ui-images": "static-2.1156",
  "UIComponents": "static-3.8423",
  "usage-tracker": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-container": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "viral-links-lib": "static-1.7068",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9675",
  "foundations-components": "static-1.7949",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.818",
  "quartz-core": "static-1.6259",
  "quick-fetch": "static-1.3920",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4658",
  "ui-addon-i18n": "static-1.11155",
  "ui-addon-upgrades": "static-9.18002",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3402",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3317",
  "quartz-webpack": "static-1.3264",
  "foundations-assets": "static-1.4871",
  "foundations-theming": "static-1.4423",
  "hub-http-shared-msw-handlers": "static-1.9972",
  "hubspotter-http": "static-1.4655",
  "sassPrefix": "static-1.156",
  "events-data-lib": "static-1.227",
  "conversations-skeleton-state": "static-1.7253",
  "crm-message-bus": "static-1.42999",
  "customer-data-filters-ui-msw-helpers": "static-1.22226",
  "customer-data-objects-ui-components": "static-1.13033",
  "customer-data-reference-ui-components": "static-1.13170",
  "customer-data-ui-utilities": "static-1.9833",
  "framework-builder-read-service-client": "static-1.4008",
  "framework-data-schema-quick-fetch": "static-1.6796",
  "framework-data-schema-resolvers": "static-1.6891",
  "inbound-db-meta-service-client": "static-1.3589",
  "inbound-db-properties-service-client": "static-1.3849",
  "multi-account-reference-resolvers": "static-1.986",
  "onboarding-tours": "static-1.16619",
  "reporting-datasets-permissions-lib": "static-1.13693",
  "ui-addon-teams": "static-1.21561",
  "quartz-auth": "static-1.715",
  "ui-business-units-lib": "static-1.9061",
  "usage-tracker-session-replay": "static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "ai-components-ui-library": "static-1.8995",
  "ContentUtils": "static-1.68375",
  "customer-data-properties": "static-1.51563",
  "forms-ai-lib": "static-1.4329",
  "forms-utils-lib": "static-1.12597",
  "foundations-components-test-utils": "static-1.5432",
  "react-dnd-compat": "static-1.4621",
  "react-tinymce": "static-1.55252",
  "tinymce-config": "static-2.54378",
  "ui-gdpr-components": "static-1.10356",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3408",
  "HeadJS": "static-2.762",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3130",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.84",
  "ui-fonts": "static-1.739",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4333",
  "csstype": "static-1.50",
  "quartz-head": "static-1.705",
  "web-vitals": "static-1.5",
  "batch-promise": "static-1.1547",
  "external-options-client-types": "static-1.4162",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.715",
  "frontend-preferences-client": "static-1.7934",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "persist-promise": "static-1.3704",
  "reporting-client-types": "static-1.2499",
  "apollo-stack-hubspot": "static-3.86",
  "growth-payments-core": "static-1.25388",
  "hubspot-apollo-client": "static-1.4885",
  "foundations-components-legacy": "static-1.974",
  "merchandise-lib": "static-1.264",
  "quartz-routing": "static-1.470",
  "hs-story-utils": "static-1.9431",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.233",
  "timezone-utils": "static-2.5250",
  "seat-types-lib": "static-1.18",
  "bend-plugin-foundations-components": "static-1.4218",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1962",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.836",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-test": "static-1.715",
  "quartz-tracking": "static-1.419",
  "bend-plugin-chirp-manifest": "static-1.68",
  "chirp-fetch": "static-1.1894",
  "purchase-motions-components": "static-1.5913",
  "salesImages": "static-1.525",
  "ts-schema": "static-1.4083",
  "bender-build-tools": "static-1.3205",
  "amplitude-session-replay-browser": "static-1.60",
  "bend-plugin-foundations-theming": "static-1.2906",
  "stylex": "static-1.33",
  "hs-resources": "static-1.156",
  "pulse": "static-1.580",
  "restore-request-side-panel-lib": "static-1.904",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3800",
  "crm-pipelines-api-client-types": "static-1.4142",
  "fdsr-migration-layer": "static-1.10",
  "multi-currency-client-types": "static-1.3694",
  "getting-started-shared-tasks": "static-1.18476",
  "growth-data-modal": "static-1.5439",
  "growth-onboarding-confetti": "static-1.3072",
  "growth-onboarding-next-action-utils": "static-1.1929",
  "navigation-components": "static-1.18058",
  "onboarding-tours-client": "static-1.4833",
  "onboarding-tours-utils": "static-1.685",
  "ui-shepherd-react": "static-3.10169",
  "ui-shepherd-tracker": "static-1.7550",
  "ui-universal-auth": "static-1.8985",
  "user-context": "static-1.5111",
  "hubspotter-http-shared-msw-handlers": "static-1.9970",
  "magpie-lib": "static-1.5555",
  "navigation-messaging": "static-1.7385",
  "chatspot-core": "static-1.21348",
  "copilot-toolkit": "static-1.11148",
  "cms-field-types": "static-1.4818",
  "content-icons-ui": "static-1.2229",
  "integrations-lib": "static-1.16152",
  "calling-global-api": "static-1.64523",
  "calling-internal-common": "static-1.31309",
  "calling-lifecycle-internal": "static-1.65905",
  "calling-lifecycle-messages": "static-1.58199",
  "commerce-products-lib": "static-1.9578",
  "crm-links": "static-1.6300",
  "customer-data-properties-shared-msw-handlers": "static-1.9299",
  "file-manager-components": "static-1.23642",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4226",
  "meetings-icalendar-utils-lib": "static-1.637",
  "object-builder-ui-client": "static-1.48759",
  "pipeline-validation-client-types": "static-1.3968",
  "property-value-citations": "static-1.2177",
  "smart-property-lib": "static-1.7065",
  "tiered-pricing": "static-1.1232",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9064",
  "final-form": "static-1.70",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19848",
  "tinymce-themes": "static-1.56348",
  "data-token-picker": "static-1.16421",
  "hub-http-contrib": "static-1.3049",
  "interframe": "static-3.4766",
  "tinymce-data": "static-1.40463",
  "tinymce-plugins": "static-1.57492",
  "ui-addon-sales-email": "static-1.5217",
  "onboarding-scopes": "static-1.6468",
  "ui-addon-opt": "static-4.8374",
  "apollo-link-hub-http": "static-2.4657",
  "hubspot-apollo-cache": "static-1.344",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.179",
  "purchase-motions-api": "static-1.5916",
  "trials-service-types": "static-1.3909",
  "bend-plugin-pulse": "static-1.83",
  "directed-graph": "static-1.942",
  "event-emitter": "static-1.954",
  "fast-json-patch": "static-1.63",
  "onboarding-data-sync-lib": "static-1.1968",
  "growth-onboarding-next-action-components": "static-1.1957",
  "user-context-client": "static-1.4619",
  "idb-keyval": "static-1.44",
  "magpie-types": "static-1.5015",
  "nest": "static-1.232",
  "reactive-lib": "static-1.730",
  "simple-logging-lib": "static-1.3056",
  "unified-auth-core-lib": "static-1.781",
  "getting-started-shared-tasks-store": "static-1.17594",
  "markdown-it": "static-1.6",
  "integrations-error-boundary-lib": "static-1.13567",
  "integrations-tracking-lib": "static-1.5607",
  "native-integrations-shared-strings": "static-1.7788",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10371",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.499",
  "calling-error-reporting": "static-1.31316",
  "shared-worker-versioning": "static-1.11042",
  "calling-usage-tracker": "static-1.6547",
  "voice-sms-access-library": "static-1.987",
  "customer-data-tracking": "static-1.6895",
  "commerce-permissions": "static-1.775",
  "products-iframe-lib": "static-1.7943",
  "products-ui-components-shared-msw-handlers": "static-1.10354",
  "location-customization-utils-lib": "static-1.9270",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4161",
  "video-components-external": "static-1.11278",
  "video-data-lib": "static-1.34936",
  "data-agent-kit": "static-1.202",
  "feedback-loader": "static-1.29307",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10055",
  "fsm": "static-1.3736",
  "policy-lib": "static-1.6784",
  "react-colorpicker": "static-2.10213",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10118",
  "FileManagerLib": "static-1.39282",
  "NamespacedHubStyle": "static-2.9062",
  "FileManagerCore": "static-1.39141",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7762",
  "layout-dnd-components": "static-1.12461",
  "layout-dnd-utils": "static-1.11436",
  "react-codemirror": "static-1.10633",
  "ui-addon-emoji-picker": "static-1.9894",
  "ui-brand-identity-lib": "static-1.15291",
  "InboxConnectUtils": "static-4.14822",
  "meetings-connect-utils-lib": "static-1.7611",
  "universal-page-editor-lib": "static-1.3018",
  "google-sheets-integration-lib": "static-1.246",
  "microsoft-drive-integration-lib": "static-1.365",
  "slack-ui-library": "static-1.10399",
  "calling-orchestration-schema": "static-1.35764",
  "sales-views-client-types": "static-1.4265",
  "crm-record-cards-service-types": "static-1.3600",
  "content-media-composition-data-lib": "static-1.12309",
  "content-media-compositions": "static-2.16316",
  "media-bridge-lib": "static-1.18939",
  "trellis-story-utils": "static-1.4522",
  "storybook-react": "static-1.33",
  "audio-components": "static-1.5924",
  "FileManagerImages": "static-1.36793",
  "video-components": "static-1.13281",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4543",
  "video-embed": "static-1.35770",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8709",
  "ui-coaching-tips": "static-1.28567",
  "ContentData": "static-1.68450",
  "layout-data-lib": "static-1.9761",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22121",
  "outpost": "static-1.4188",
  "growth-onboarding-feedback-components": "static-1.6587",
  "advanced-menus-core": "static-1.15138",
  "advanced-menus-lib": "static-1.12077",
  "ExportDialog": "static-6.10395",
  "ui-memberships-settings-lib": "static-1.34056",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15137",
  "simple-menus-lib": "static-1.16654"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34527",
  "atom": "/atom/static-1.5078",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2502",
  "client-types": "/client-types/static-1.466",
  "cssUtils": "/cssUtils/static-1.794",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39791",
  "customer-data-objects": "/customer-data-objects/static-1.7675",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8096",
  "documents-lib": "/documents-lib/static-1.34532",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.338",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85860",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4725",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2139",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5598",
  "hs-test-utils": "/hs-test-utils/static-1.8019",
  "hub-http": "/hub-http/static-1.6228",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11784",
  "HubStyleTokens": "/HubStyleTokens/static-2.11477",
  "I18n": "/I18n/static-7.1628",
  "icons": "/icons/static-2.647",
  "jasmine-immutable": "/jasmine-immutable/static-1.3027",
  "jasmine-runner": "/jasmine-runner/static-1.6470",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7162",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5407",
  "quartz": "/quartz/static-1.7040",
  "react": "/react/static-7.186",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1-feat-id-1323-initial-url.10",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5348",
  "react-virtualized": "/react-virtualized/static-2.99",
  "reference-resolvers": "/reference-resolvers/static-1.8177",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8100",
  "reporting-data": "/reporting-data/static-1.67566",
  "reporting-reports": "/reporting-reports/static-1.67244",
  "reporting-snowflake": "/reporting-snowflake/static-1.56184",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9499",
  "reporting-visualizations": "/reporting-visualizations/static-1.59642",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8949",
  "sanitize": "/sanitize/static-1.4483",
  "sanitize-text": "/sanitize-text/static-1.8148",
  "self-service-api": "/self-service-api/static-1.10254",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1754",
  "signup-constants": "/signup-constants/static-1.18848",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8055",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "superstore": "/superstore/static-1.4767",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4768",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10996",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11041",
  "ui-images": "/ui-images/static-2.1156",
  "UIComponents": "/UIComponents/static-3.8423",
  "usage-tracker": "/usage-tracker/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-container": "/usage-tracker-container/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "usage-tracker-core": "/usage-tracker-core/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "viral-links-lib": "/viral-links-lib/static-1.7068",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9675",
  "foundations-components": "/foundations-components/static-1.7949",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.818",
  "quartz-core": "/quartz-core/static-1.6259",
  "quick-fetch": "/quick-fetch/static-1.3920",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4658",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11155",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18002",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3402",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3317",
  "quartz-webpack": "/quartz-webpack/static-1.3264",
  "foundations-assets": "/foundations-assets/static-1.4871",
  "foundations-theming": "/foundations-theming/static-1.4423",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9972",
  "hubspotter-http": "/hubspotter-http/static-1.4655",
  "sassPrefix": "/sassPrefix/static-1.156",
  "events-data-lib": "/events-data-lib/static-1.227",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7253",
  "crm-message-bus": "/crm-message-bus/static-1.42999",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22226",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13033",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13170",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9833",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4008",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6796",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6891",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3589",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3849",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.986",
  "onboarding-tours": "/onboarding-tours/static-1.16619",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13693",
  "ui-addon-teams": "/ui-addon-teams/static-1.21561",
  "quartz-auth": "/quartz-auth/static-1.715",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9061",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-sai-cwunder-add-replay-recorded-event-6646.10",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8995",
  "ContentUtils": "/ContentUtils/static-1.68375",
  "customer-data-properties": "/customer-data-properties/static-1.51563",
  "forms-ai-lib": "/forms-ai-lib/static-1.4329",
  "forms-utils-lib": "/forms-utils-lib/static-1.12597",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5432",
  "react-dnd-compat": "/react-dnd-compat/static-1.4621",
  "react-tinymce": "/react-tinymce/static-1.55252",
  "tinymce-config": "/tinymce-config/static-2.54378",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10356",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3408",
  "HeadJS": "/HeadJS/static-2.762",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3130",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.84",
  "ui-fonts": "/ui-fonts/static-1.739",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4333",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.705",
  "web-vitals": "/web-vitals/static-1.5",
  "batch-promise": "/batch-promise/static-1.1547",
  "external-options-client-types": "/external-options-client-types/static-1.4162",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.715",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7934",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3704",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "growth-payments-core": "/growth-payments-core/static-1.25388",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4885",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.974",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "quartz-routing": "/quartz-routing/static-1.470",
  "hs-story-utils": "/hs-story-utils/static-1.9431",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.233",
  "timezone-utils": "/timezone-utils/static-2.5250",
  "seat-types-lib": "/seat-types-lib/static-1.18",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4218",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1962",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-test": "/quartz-test/static-1.715",
  "quartz-tracking": "/quartz-tracking/static-1.419",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.68",
  "chirp-fetch": "/chirp-fetch/static-1.1894",
  "purchase-motions-components": "/purchase-motions-components/static-1.5913",
  "salesImages": "/salesImages/static-1.525",
  "ts-schema": "/ts-schema/static-1.4083",
  "bender-build-tools": "/bender-build-tools/static-1.3205",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2906",
  "stylex": "/stylex/static-1.33",
  "hs-resources": "/hs-resources/static-1.156",
  "pulse": "/pulse/static-1.580",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.904",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3800",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4142",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.10",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3694",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18476",
  "growth-data-modal": "/growth-data-modal/static-1.5439",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3072",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1929",
  "navigation-components": "/navigation-components/static-1.18058",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4833",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.685",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10169",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7550",
  "ui-universal-auth": "/ui-universal-auth/static-1.8985",
  "user-context": "/user-context/static-1.5111",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9970",
  "magpie-lib": "/magpie-lib/static-1.5555",
  "navigation-messaging": "/navigation-messaging/static-1.7385",
  "chatspot-core": "/chatspot-core/static-1.21348",
  "copilot-toolkit": "/copilot-toolkit/static-1.11148",
  "cms-field-types": "/cms-field-types/static-1.4818",
  "content-icons-ui": "/content-icons-ui/static-1.2229",
  "integrations-lib": "/integrations-lib/static-1.16152",
  "calling-global-api": "/calling-global-api/static-1.64523",
  "calling-internal-common": "/calling-internal-common/static-1.31309",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65905",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58199",
  "commerce-products-lib": "/commerce-products-lib/static-1.9578",
  "crm-links": "/crm-links/static-1.6300",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9299",
  "file-manager-components": "/file-manager-components/static-1.23642",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4226",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.637",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48759",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3968",
  "property-value-citations": "/property-value-citations/static-1.2177",
  "smart-property-lib": "/smart-property-lib/static-1.7065",
  "tiered-pricing": "/tiered-pricing/static-1.1232",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9064",
  "final-form": "/final-form/static-1.70",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19848",
  "tinymce-themes": "/tinymce-themes/static-1.56348",
  "data-token-picker": "/data-token-picker/static-1.16421",
  "hub-http-contrib": "/hub-http-contrib/static-1.3049",
  "interframe": "/interframe/static-3.4766",
  "tinymce-data": "/tinymce-data/static-1.40463",
  "tinymce-plugins": "/tinymce-plugins/static-1.57492",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5217",
  "onboarding-scopes": "/onboarding-scopes/static-1.6468",
  "ui-addon-opt": "/ui-addon-opt/static-4.8374",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4657",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.344",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.179",
  "purchase-motions-api": "/purchase-motions-api/static-1.5916",
  "trials-service-types": "/trials-service-types/static-1.3909",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.83",
  "directed-graph": "/directed-graph/static-1.942",
  "event-emitter": "/event-emitter/static-1.954",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1968",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1957",
  "user-context-client": "/user-context-client/static-1.4619",
  "idb-keyval": "/idb-keyval/static-1.44",
  "magpie-types": "/magpie-types/static-1.5015",
  "nest": "/nest/static-1.232",
  "reactive-lib": "/reactive-lib/static-1.730",
  "simple-logging-lib": "/simple-logging-lib/static-1.3056",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.781",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17594",
  "markdown-it": "/markdown-it/static-1.6",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13567",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5607",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7788",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10371",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.499",
  "calling-error-reporting": "/calling-error-reporting/static-1.31316",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11042",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6547",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.987",
  "customer-data-tracking": "/customer-data-tracking/static-1.6895",
  "commerce-permissions": "/commerce-permissions/static-1.775",
  "products-iframe-lib": "/products-iframe-lib/static-1.7943",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10354",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9270",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4161",
  "video-components-external": "/video-components-external/static-1.11278",
  "video-data-lib": "/video-data-lib/static-1.34936",
  "data-agent-kit": "/data-agent-kit/static-1.202",
  "feedback-loader": "/feedback-loader/static-1.29307",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10055",
  "fsm": "/fsm/static-1.3736",
  "policy-lib": "/policy-lib/static-1.6784",
  "react-colorpicker": "/react-colorpicker/static-2.10213",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10118",
  "FileManagerLib": "/FileManagerLib/static-1.39282",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9062",
  "FileManagerCore": "/FileManagerCore/static-1.39141",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7762",
  "layout-dnd-components": "/layout-dnd-components/static-1.12461",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11436",
  "react-codemirror": "/react-codemirror/static-1.10633",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9894",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15291",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14822",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7611",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3018",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.246",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.365",
  "slack-ui-library": "/slack-ui-library/static-1.10399",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35764",
  "sales-views-client-types": "/sales-views-client-types/static-1.4265",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3600",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12309",
  "content-media-compositions": "/content-media-compositions/static-2.16316",
  "media-bridge-lib": "/media-bridge-lib/static-1.18939",
  "trellis-story-utils": "/trellis-story-utils/static-1.4522",
  "storybook-react": "/storybook-react/static-1.33",
  "audio-components": "/audio-components/static-1.5924",
  "FileManagerImages": "/FileManagerImages/static-1.36793",
  "video-components": "/video-components/static-1.13281",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4543",
  "video-embed": "/video-embed/static-1.35770",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8709",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28567",
  "ContentData": "/ContentData/static-1.68450",
  "layout-data-lib": "/layout-data-lib/static-1.9761",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22121",
  "outpost": "/outpost/static-1.4188",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6587",
  "advanced-menus-core": "/advanced-menus-core/static-1.15138",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12077",
  "ExportDialog": "/ExportDialog/static-6.10395",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34056",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15137",
  "simple-menus-lib": "/simple-menus-lib/static-1.16654"
}
};
